import { render, staticRenderFns } from "./Aneel1_XMLProjeto.vue?vue&type=template&id=01cd9286&"
import script from "./Aneel1_XMLProjeto.vue?vue&type=script&lang=js&"
export * from "./Aneel1_XMLProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports